(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminAssetDisplaySettingsController', AdminAssetDisplaySettingsController);

    function AdminAssetDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        assetScoreTypesCollection,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'default_asset_score_types'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);

        vm.settings.default_asset_score_types.value = vm.settings.default_asset_score_types.value.map(function (item) {
            const newItem = {
                name: item.name,
                active: false
            };

            const scoreType = lodash.find(assetScoreTypesCollection.scoreTypes, {'id': item.id});
            if (scoreType && scoreType.active) {
                newItem.active = true;
            }

            return newItem;
        });
    }
})();
